module.exports = __webpack_public_path__ + "202408221624/img/7.30156412.png";